import React from 'react';
import { Image } from 'react-bootstrap';

import { DisplayImage } from 'helper/products/meteorology';

import './index.scss';

export default function MeteorologyFieldsImage({
  image,
  selectImage,
} : {
  image: DisplayImage,
  selectImage: () => void,
}) {
  return (
    <div className="d-flex justify-content-center">
      <Image
        fluid
        alt=""
        src={`data:image/png;base64,${image.base64}`}
        className="clickable-image meteorology-fields-display-row-image"
        onClick={selectImage}
      />
    </div>
  );
}
